import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * OAuth Callback Component
 * Handles the FusionAuth OAuth redirect. The FusionAuth SDK (RequireAuth)
 * handles the actual code-for-token exchange before this component renders.
 * This component just redirects to the map after the SDK completes auth.
 */
const OAuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const error = searchParams.get('error');

    if (error) {
      console.error('[OAuthCallback] OAuth error:', error);
      navigate('/login');
      return;
    }

    // SDK has already handled the code exchange via RequireAuth.
    // Redirect to the map.
    console.log('[OAuthCallback] Auth handled by SDK, redirecting to map');
    navigate('/map');
  }, [searchParams, navigate]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      padding: '20px'
    }}>
      <h2>Processing Authentication...</h2>
      <p>Redirecting...</p>
    </div>
  );
};

export default OAuthCallback;
